export default __webpack_public_path__ + "images/SummerCompanyOnboardingBackground.web.png";